import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import FieldLabelWrapper from '../../../../../../features/components/Form/FieldLabelWrapper'
import FrequencyFields from '../../../../reusableFormFields/FrequencyFields'
import ErrorMessage from '../../../../../../components/Form/ErrorMessage'
import Checkbox from '../../../../../../components/Form/Checkbox'

import { OPTION_NO, OPTION_YES } from '../../../../../../constants/forms'

import { FREQUENCY_IMPRESSIONS, FREQUENCY_OPTION } from '../../../../fields'

import useStyles from './styles'

const FrequencyCapFields = ({ formik }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const { values, errors, touched, setFieldValue } = formik

  const frequencyCapCheckboxHandler = useCallback(() => {
    const frequencyOption = values[FREQUENCY_OPTION]
    const newFrequencyOptionValue = frequencyOption === OPTION_YES ? OPTION_NO : OPTION_YES
    setFieldValue(FREQUENCY_OPTION, newFrequencyOptionValue)
  }, [setFieldValue, values])

  return (
    <FieldLabelWrapper label={t('Frequency')}>
      <Checkbox
        className={classes.frequencyCapCheckbox}
        id="checkbox_set_campaign_level_frequency_cap"
        title="Set campaign level frequency cap"
        checked={values[FREQUENCY_OPTION] === OPTION_YES}
        onCheck={frequencyCapCheckboxHandler}
      />
      {values[FREQUENCY_OPTION] === OPTION_YES && (
        <>
          <FrequencyFields formik={formik} />
          {errors[FREQUENCY_IMPRESSIONS] && touched[FREQUENCY_IMPRESSIONS] && (
            <ErrorMessage error={errors[FREQUENCY_IMPRESSIONS]} />
          )}
        </>
      )}
    </FieldLabelWrapper>
  )
}

export default FrequencyCapFields
